<template>
  <div class="blog-container">
    <HundredItem
      v-for="item in itemList"
      :key="item.articleId"
      :every="item"
      :curcer="item.articleId"
      @itemClick="goDetail"
    ></HundredItem>
    <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
  </div>
</template>

<script>
import HundredItem from "@/components/pager/HundredItem.vue";
import mixin from "@/mixins/scrollPager";
import Scroll from "@/components/paging/scroll";
import { mapState } from "vuex";
export default {
  components: {
    HundredItem,
    Scroll
  },
  mixins: [mixin],
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      params: {
        id: this.$route.query.id,
        pageNo: 1,
        pageSize: 10,
        userType: 2,
      },
    };
  },
  created() {
    this.getList(this.params);
  },
  methods: {
    async getList(data) {
      const resp = await this.$apis.hundredServe.getSyncBkThesisList(data);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 10;
    },
    goDetail(e) {
      // 跳转论文详情静态页面首页
      window.open(`${this.$global.SeoUrl}thesisDetail?type=0&id=${e.articleId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-container {
  background-color: #fff;
  min-height: 700px;
  padding-bottom: 19px;
}
</style>
